document.addEventListener('DOMContentLoaded', function () {
  const reviews = Array.from(
    document.querySelectorAll('.reviews-container ul li')
  );

  const readMoreBtn = document.querySelector('.read-more');
  const width = window.innerWidth;
  let shown = 3;
  let imageCounter = 1;

  function hideReviews(shown) {
    for (let i = shown; i < reviews.length; i++) {
      const review = reviews[i];
      review.classList.add('hidden');
    }
  }

  function showReviews(shown) {
    let counter = 0;
    imageCounter++;

    for (let i = 0; i < reviews.length; i++) {
      const review = reviews[i];

      if (review.classList.contains('hidden')) {
        review.classList.remove('hidden');
        counter++;
      }

      if (counter === shown) {
        break;
      }
    }

    const image = document.querySelector(
      `.side-image[data-index="${imageCounter}"]`
    );

    if (image) {
      image.classList.remove('hidden');
    }
  }

  if (width > 991) shown = 4;
  hideReviews(shown);

  readMoreBtn.addEventListener('click', () => {
    showReviews(shown);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth < 991 && shown === 4) {
      shown = 3;
    } else if (window.innerWidth >= 991 && shown === 3) {
      shown = 4;
    }
  });
});
